module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"8","viewBox":"0 0 10 8"},"content":"<g fill=\"#B5BEC8\" fill-rule=\"evenodd\"><rect width=\"10\" height=\"1.6\" rx=\".8\"/><rect width=\"10\" height=\"1.6\" y=\"6.4\" rx=\".8\"/><rect width=\"10\" height=\"1.6\" y=\"3.2\" rx=\".8\"/></g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/hamburger.svg
// module id = 1415
// module chunks = 0